Ext.define('SA.VectorMapExtent', {
    statics: {
        fromLngLatBounds([southWest, northEast]) {
            return new SA.VectorMapExtent(SA.VectorMapCoordinate.fromLngLat(southWest), SA.VectorMapCoordinate.fromLngLat(northEast));
        },

        fromXYBounds([west, south, east, north]) {
            return new SA.VectorMapExtent(SA.VectorMapCoordinate.fromXY([west, south]), SA.VectorMapCoordinate.fromXY([east, north]));
        }
    },

    constructor(southWest, northEast) {
        this.northEast = northEast;
        this.southWest = southWest;
    },

    equals(other) {
        return this.getSouthWest().equals(other?.getSouthWest()) && this.getNorthEast().equals(other?.getNorthEast());
    },

    getAspectRatio() {
        return this.getWidth() / this.getHeight();
    },

    getCenter() {
        var x = (this.getSouthWest().getX() + this.getNorthEast().getX()) / 2,
            y = (this.getSouthWest().getY() + this.getNorthEast().getY()) / 2;

        return SA.VectorMapCoordinate.fromXY([x, y]);
    },

    getEast() {
        return this.getNorthEast().getX();
    },

    getHeight() {
        return this.getNorth() - this.getSouth();
    },

    getNorth() {
        return this.getNorthEast().getY();
    },

    getNorthEast() {
        return this.northEast;
    },

    getSouth() {
        return this.getSouthWest().getY();
    },

    getSouthWest() {
        return this.southWest;
    },

    getWest() {
        return this.getSouthWest().getX();
    },

    getWidth() {
        return this.getEast() - this.getWest();
    },

    scale(sx, sy = sx) {
        var center = this.getCenter(),
            newWidth = this.getWidth() * sx,
            newHeight = this.getHeight() * sy,
            southWest = new SA.VectorMapCoordinate(center.getX() - newWidth / 2, center.getY() - newHeight / 2),
            northEast = new SA.VectorMapCoordinate(center.getX() + newWidth / 2, center.getY() + newHeight / 2);

        return new SA.VectorMapExtent(southWest, northEast);
    },

    toLngLatBounds() {
        return [this.getSouthWest().toLngLat(), this.getNorthEast().toLngLat()];
    },

    toXYBounds() {
        return [...this.getSouthWest().toXY(), ...this.getNorthEast().toXY()];
    }
});